import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchPublishedGatings } from "actions/gating";
import { fetchPage, searchPages } from "actions/pages";
import {
  createGatingConfig, updateGatingConfig, deleteGatingConfig
} from 'actions/storyboard';

import GatingConfigurations from "components/gatings";
import storyboardRoleService from "services/storyboardRoles.service";

import _ from 'lodash';
import shortid from "shortid";
import cx from 'classnames';

import {
  Button,
} from "react-bootstrap";

import styles from './websiteSettings.module.scss';

export const ContentGating = ({ storyboard, isGatingSettings, gatingInEditor=false }) => {
  const dispatch = useDispatch();

  const gatingConfigs = useSelector((state) => _.get(state, "storyboards.storyboard.item.gatingConfigurations", [])) || [];

  const isSmartEnabled = gatingConfigs?.find((gatingConfig) => gatingConfig.smart && gatingConfig.enabled);

  useEffect(() => {
    dispatch(fetchPublishedGatings({
      storyboard: storyboard.id,
      published: true
    }, 0, 50));
  }, [storyboard.id]);

  useEffect(() => {
    fetchPages();

    if (storyboard.page && !isGatingSettings) {
      if (storyboard.page && storyboard.type === 'INTERACTIVE_CONTENT') {
        dispatch(fetchPage(storyboard.page.id));
      }
    }
  }, []);

  const createNewGating = () => {
    var request = {
      uid: shortid(),
      name: 'Untitled Gating',
      enabled: false,
      optional: false,
      trigger: { type: 'TIME', value: 10 },
      target: null
    }

    dispatch(createGatingConfig(request));
  }

  const fetchPages = () => {
    if (storyboard && storyboard.type !== 'INTERACTIVE_CONTENT') {
      var request = {
        storyboard: storyboard.id
      }

      dispatch(searchPages(request, 0, 50));
    }
  }

  const handleUpdate = (id, request) => {
    dispatch(updateGatingConfig(id, request));
  }

  const handleDelete = (id) => {
    dispatch(deleteGatingConfig(id)); 
  }

  return (
    <div
      id="contentGating"
      className={cx(styles.gatingContainer)}
      data-style="gatingContainer"
    >
      <div className={styles.gatingWrapper} data-style="gatingWrapper">
        {!isGatingSettings && (
          <div className={styles.headerSection}>
            <SiteSettingHeader title="Gating Triggers" description="" />
            <div className={styles.newGatingSection}>
              <Button
                disabled={!storyboardRoleService.canEditStoryboard(storyboard)}
                variant="secondary"
                onClick={createNewGating}
                className={styles.createGatingButton}
              >
                <i className={cx("cleverstory-plus", styles.addIcon)} />
                New Gating
              </Button>
            </div>
          </div>
        )}

        <div
          className={styles.gatingConfigurationsWrapper}
          data-style="gatingConfigurationsWrapper"
        >
          {gatingConfigs.length === 0 && (
            <div className={styles.emptySmartGatingContainer}>
              <div className={styles.emptyMessage}>
                <div className={styles.errorMessageContent}>
                  <div className={styles.errorMessageTitle}>
                    <h2
                      className={cx(styles.heading, styles.gatingHeading)}
                    >
                      Weather forecast
                    </h2>
                  </div>
                  <div
                    className={cx(
                      styles.errorMessageSubText,
                      styles.gatingErrorMessageSubText
                    )}
                  >
                    <span>
                      Clear skies and <br /> empty screens
                    </span>
                  </div>
                </div>
                <img
                  className={cx(styles.emptySmartGatingImage)}
                  src=""
                  alt="emptyMedia_image"
                />
              </div>
            </div>
          )}
          {gatingConfigs.map((gatingConfig) => (
            <React.Fragment key={gatingConfig.id}>
              <GatingConfigurations
                gatingConfig={gatingConfig}
                storyboard={storyboard}
                onUpdate={handleUpdate}
                onDelete={handleDelete}
                type={"page"}
                isSmartEnabled={isSmartEnabled}
                className={styles.gatingContent}
              />
              <hr className={styles.gatingSeperator} />
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}

const SiteSettingHeader = ({ title, description }) => {

  return (
    <header className={styles.siteSettingsHeader}>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.description}>{description}</p>
    </header>
  )
}

